// extracted by mini-css-extract-plugin
export default {"label-group":"dropboxer_card_label-group__jbGyV","label-avatar":"dropboxer_card_label-avatar__avlkb","label-text":"dropboxer_card_label-text__GJfou"};